/*
main.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
// Define the files that make up the application shell
define('modules/shell/main',[
    './module',
    './services/application.service',
    './services/activitytracker.service',
    './services/login.service',
    './services/token.service',
    './services/user.service',
    './controllers/shell.controller',
    './controllers/header.controller',
    './controllers/vertical-menu.controller',
    './controllers/session-management.controller',
    './services/get-locale.service',
    './services/app.configuration.service',
    './services/localized-options-service'
], function (module) {
    return module;
});

